<template>
    <div class="sbs-accordion">
        <!-- @slot Слот по-умолчанию для компонентов `SbsAccordionItem` -->
        <slot></slot>
    </div>
</template>

<script>
import { animate } from './utils/utils.js';

const ANIMATE_DURATION = 300;

/**
 * Компонент, предназначенный для объединения в группу SbsAccordionItem
 */
export default {
    name: 'SbsAccordion',
    provide() {
        return {
            accordionComponent: this,
        };
    },
    emits: ['update:modelValue', 'SbsAccordion:change'],
    methods: {
        accordionChangeHandler(itemId, event) {
            let value = itemId === this.modelValue
                ? ''
                : itemId;

            if (this.multiple) {
                value = Array.isArray(this.modelValue)
                    ? [...this.modelValue]
                    : [];

                const itemIndex = value.indexOf(itemId);

                if (itemIndex > -1) {
                    value.splice(itemIndex, 1);
                } else {
                    value.push(itemId);
                }
            } else {
                this.animateScroll(event);
            }

            /**
             * Событие `update:modelValue` срабатывает при открытии/закрытии секции аккордеона.
             * В качестве параметра - значение после изменения и объект события
             */
            this.$emit('update:modelValue', value);
        },
        animateScroll(e) {
            const targetHeight = e.target.offsetHeight;
            const currentSection = e.target;
            const currentSectionTop = currentSection?.getBoundingClientRect()?.top ?? 0;
            const openedSection = document.querySelector('div[data-active]');
            const openedSectionTop = openedSection?.getBoundingClientRect()?.top ?? 0;
            const openedSectionHeight = openedSection?.offsetHeight ?? 0;
            const newTop = currentSectionTop - openedSectionHeight + targetHeight + window.pageYOffset;

            if (currentSection !== openedSection && (openedSectionTop < 0 || openedSectionTop > window.innerHeight)) {
                animate(percentage => {
                    const { scrollTop } = document.documentElement;

                    if (scrollTop > newTop) {
                        document.documentElement.scrollTop -= (scrollTop - newTop) * percentage;
                    }
                }, ANIMATE_DURATION);
            }
        },
    },
    props: {
        /**
         * Позволяет множественное открывание элементов
         */
        multiple: {
            type: Boolean,
            default: false,
        },
        /**
         * Id текущей открытой секции аккордеона
         * @model
         */
        modelValue: {
            type: [String, Array],
            default: '',
        },
    },
};
</script>

<style lang="scss">
.sbs-accordion {
    display: flex;
    flex-direction: column;
}
</style>
